import { resolveRuntimeEnvFromHostname } from "common/constants/env";

const ENV_PREFIXES: Record<string, string> = {
  prod: "",
  stage: "[STAGE] ",
  qa: "[QA] ",
  demo1: "[DEMO1] ",
  demo2: "[DEMO2] ",
  develop: "[DEV] ",
  pr: "[PR] ",
};

/**
 * Environment-specific prefix for the page title, resolved from the hostname so a single build
 * shows the right label wherever it is served.
 */
function envPrefix(): string {
  if (typeof window === "undefined") {
    return "";
  }
  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "[LOCAL] ";
  }
  const sandbox = hostname.match(/^app\.(sandbox\d+)\.higharc\.com$/);
  if (sandbox) {
    return `[${sandbox[1].toUpperCase()}] `;
  }
  return ENV_PREFIXES[resolveRuntimeEnvFromHostname(hostname)] ?? "[LOCAL] ";
}

/**
 * Format a page title with environment specific prefixes.
 */
export default function getPageTitle(title?: string | number): string {
  const env = envPrefix();

  if (title) {
    return `${env}Higharc - ${title}`;
  }

  return `${env}Higharc`;
}
